import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const CalendarIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc>calendar</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="M139 62.4h-11.6v3.4c0 4.3-2.8 7.6-6.4 7.6h-1c-3.6 0-6.4-3.3-6.4-7.6v-3.4H86v3.4c0 4.3-2.8 7.6-6.4 7.6h-1c-3.6 0-6.4-3.3-6.4-7.6v-3.4H60.5a4.9 4.9 0 0 0-4.8 4.9v67.5a4.9 4.9 0 0 0 4.8 4.8h78.6a4.9 4.9 0 0 0 4.8-4.8V67.3a4.9 4.9 0 0 0-4.8-4.9Zm-.6 67.8a3.9 3.9 0 0 1-3.9 4H65.1a3.9 3.9 0 0 1-3.9-4V83a3.9 3.9 0 0 1 3.9-3.9h69.4a3.9 3.9 0 0 1 4 3.9Z"
        className="accent"
      />
      <path
        d="M83.3 56.3v9.5c0 2.7-1.7 4.9-3.7 4.9h-1c-2 0-3.6-2.2-3.6-4.9v-9.5c0-2.7 1.6-5 3.6-5h1c2 0 3.7 2.3 3.7 5Zm41.3 0v9.5c0 2.7-1.6 4.9-3.6 4.9h-1c-2 0-3.7-2.2-3.7-4.9v-9.5c0-2.7 1.7-5 3.7-5h1c2 0 3.6 2.3 3.6 5ZM97.8 91c-2.7 5.4-3.2 6.3-5.5 11.4 4 .5 6.9 3.7 6.9 8.8s-3 12-13.9 12a25.5 25.5 0 0 1-8.8-1.6l-.1-.3v-7l.5-.2a10.6 10.6 0 0 0 6.4 2.4c3.4 0 5.4-2 5.4-4.7a4.4 4.4 0 0 0-4.6-4.4 4.8 4.8 0 0 0-2.5.6l-.3-.2c1.8-4 2.6-6.2 4-10l-9 .3-.3-.3.4-6.7.3-.4h9c4 0 7.4 0 11.9-.2Zm9.1 6.7-.3-.3.4-5.6.3-.3 13-1.7.3.3-.2 18.9c0 6.6.2 10.2.4 13.1l-.4.4c-3.9 0-5.1 0-9.5.2l-.2-.4c.2-8.4.3-12 .3-18.6v-6.2Z"
        className="accent"
      />
    </Icon>
  );
};

export default CalendarIcon;
